<div class="content-card">
  <div class="header inline-element">
    <mat-button-toggle-group [(ngModel)]="buscarEm" style="height: 42px !important;">
      <mat-button-toggle [value]="origemBanco">{{tipoBancoNome}}</mat-button-toggle>
      <mat-button-toggle [value]="origemCaixa">Caixa</mat-button-toggle>
    </mat-button-toggle-group>

    <mat-button-toggle-group [(ngModel)]="targetIsPositive" style="height: 42px !important;">
      <mat-button-toggle [value]="true">Credito</mat-button-toggle>
      <mat-button-toggle [value]="false">Debito</mat-button-toggle>
    </mat-button-toggle-group>

    <p-floatlabel variant="on">
      <p-inputNumber inputId="searchValue" [inputStyle]="{ width: '150px' }" mode="currency" currency="BRL"
      [(ngModel)]="searchValue" (keyup.enter)="applySearch(false, false)"></p-inputNumber>
      <label for="searchValue">Search value</label>
    </p-floatlabel>

    <mat-chip (click)="buscarDiferenca()">
      Diferença entre valores selecionados: R$ {{diferencaValoresSelecionados | number : '1.2-2'}}
    </mat-chip>

    <button mat-raised-button (click)="aceitarCorrespondenciaSelecionado()" class="center-vertically">
      Aceitar correspondencia dos itens selecionados
    </button>

    <button mat-raised-button class="mais-opcoes-btn" [matMenuTriggerFor]="menuFiltros" matTooltip="Mais opções">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menuFiltros="matMenu">
      <button mat-menu-item class="inline-element" (click)="openFilters()">
        <mat-icon class="accent-color">tune</mat-icon>
        Editar filtros
      </button>
      <button mat-menu-item class="inline-element" [disabled]="!modoEdicao" (click)="openFiltrosBuscaEmMassa()">
        <mat-icon class="accent-color">auto_fix_high</mat-icon>
        Buscar correspondências em massa
      </button>
      <button mat-menu-item class="inline-element" (click)="openCorrespondenciasComDiferenca()">
        <mat-icon class="accent-color">visibility</mat-icon>
        Correspondências com diferença
      </button>
    </mat-menu>
  </div>

  @if (searching) {
    <mat-spinner color="accent"></mat-spinner>
  }
  @if (!searching && !existeResultadosConciliados) {
    <div class="no-matches-found">
      Nenhuma correspondência encontrada
    </div>
  }

  @if (!searching && existeResultadosConciliados) {
    <div class="match-container">
      <div class="match-space">
        @for (result of resultadosConciliados; track result; let i = $index) {
          <div class="match-found">
            @if (result.length > 0) {
              <div>
                <div class="inline-element match-header">
                  <h3>Correspondência {{ i + 1 }}</h3>
                  @if (correspondenciaConciliacaoIndex !== null) {
                    <button mat-raised-button color="primary" [disabled]="!modoEdicao"
                      (click)="removerCorrespondenciaClick()">
                      Remover Correspondencia
                    </button>
                  }
                  @if (correspondenciaConciliacaoIndex === null && permiteConciliar) {
                    <button mat-raised-button color="primary" [disabled]="!modoEdicao"
                      (click)="aceitarCorrespondenciaSugeridoClick(i)">
                      Aceitar Correspondencia
                    </button>
                  }
                  @if (correspondenciaConciliacaoIndex === null && !permiteConciliar) {
                    <button mat-raised-button color="primary" [disabled]="true"
                      (click)="aceitarCorrespondenciaSugeridoClick(i)">
                      Lançamento conciliado selecionado
                    </button>
                  }
                </div>
                <p-table [value]="result" responsiveLayout="scroll">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Encontrado</th>
                      <th>Data</th>
                      <th>Lançamento</th>
                      <th>Valor</th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-element let-rowIndex="rowIndex">
                    <tr [pSelectableRow]="element" [pSelectableRowIndex]="rowIndex">
                      <td>
                        <mat-checkbox class="example-margin" [(ngModel)]="element.conciliado" [disabled]="true"></mat-checkbox>
                      </td>
                      <td>{{ element.data | date:'dd/MM/yyyy' }}</td>
                      <td>{{ element.descricao }}</td>
                      <td>{{ element.valor | currency:'BRL' }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

</div>